module.exports = __webpack_public_path__ + "img/4NP.4c5ca85b.png";